import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-content">
          {/* Logo Section */}
          <div className="footer-logo">
            <span className="material-symbols-outlined footer-logo-icon">phonelink_lock</span>
            <h2 className="footer-logo-text">OpenSMS</h2>
          </div>

          {/* Links Section */}
          <div className="footer-links">
            <Link to="/about" className="footer-link">About</Link>
            <Link to="/contact" className="footer-link">Contact</Link>
            <a href="/terms-conditions" className="footer-link">Terms of Service</a>
            <a href="/privacy-policy" className="footer-link">Privacy Policy</a>
          </div>

          {/* Copyright */}
          <p className="footer-copyright">
            © 2024 OpenSMS. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
